import objectPath from 'object-path'

const MAESTRO = {
	install (Vue, options) {
		Vue.prototype.$maestro = {

			getJrRestartableTasks (jr, jr_id) {
				return new Promise(async (resolve, reject) => {
					if (jr_id && !jr) {
						try {
							jr = await window.vm.$EsMaestro.jobrequest_read(jr_id)
						} catch (error) {
							reject(error)
						}
					}
					let jrStatusEnabled = [
						window.vm.$getConst('ERROR'),
						window.vm.$getConst('STOPPED')
					]
					let taskStatusEnabled = [
						window.vm.$getConst('ERROR'),
						window.vm.$getConst('STOPPED'),
						window.vm.$getConst('DONE')
					]
					if (jrStatusEnabled.indexOf(jr.status) > -1) {
						try {
							let response = await window.vm.$ApiMaestro.jobrequest_restartables(jr.id)
							let restartables = objectPath.get(response, 'data.restartables', [])
							if (restartables.indexOf('__all__') > -1) {
								let taskIds = jr.tasks
									.filter(task => taskStatusEnabled.indexOf(task.status) > -1)
									.map(task => task.descriptor_id)
								resolve(taskIds)
							} else {
								resolve(restartables)
							}
						} catch (error) {
							reject(error)
						}
					} else {
						resolve([])
					}
				})
			},

			babel_card_label (babel_card) {
				let familyLabels = []
				let grandParentLabel = babel_card.grand_parent_label
				if (!grandParentLabel) {
					grandParentLabel = objectPath.get(babel_card, 'parent.parent.label', '')
				}
				let parentLabel = babel_card.parent_label
				if (!parentLabel) {
					parentLabel = objectPath.get(babel_card, 'parent.label', '')
				}
				let childLabel = babel_card.label.trim()
				if (grandParentLabel) {
					familyLabels.push(grandParentLabel)
					parentLabel = parentLabel
						.replace(grandParentLabel, '')
						.replace(/^[\s-]+|[\s-]+$/g, '')
				}
				if (parentLabel) {
					familyLabels.push(parentLabel)
					childLabel = childLabel
						.replace(parentLabel, '')
						.replace(/^[\s-]+|[\s-]+$/g, '')
				}
				familyLabels.push(childLabel)
				return familyLabels.join(' / ')
			},

			babel_card_sort_label (babel_card) {
				let familyLabels = []
				let grandParentLabel = babel_card.grand_parent_label
				if (!grandParentLabel) {
					grandParentLabel = objectPath.get(babel_card, 'parent.parent.label', '')
				}
				let parentLabel = babel_card.parent_label
				if (!parentLabel) {
					parentLabel = objectPath.get(babel_card, 'parent.label', '')
				}
				let childLabel = babel_card.label.trim()
				if (grandParentLabel) {
					let grandParentIndex = babel_card.grand_parent_index || 0
					grandParentIndex = grandParentIndex.toString().padStart(5, '0')
					familyLabels.push(grandParentIndex)
					familyLabels.push(grandParentLabel)
					parentLabel = parentLabel
						.replace(grandParentLabel, '')
						.replace(/^[\s-]+|[\s-]+$/g, '')
				}
				if (parentLabel) {
					let parentIndex = babel_card.parent_index || 0
					parentIndex = parentIndex.toString().padStart(5, '0')
					familyLabels.push(parentIndex)
					familyLabels.push(parentLabel)
					childLabel = childLabel
						.replace(parentLabel, '')
						.replace(/^[\s-]+|[\s-]+$/g, '')
				}
				let childIndex = babel_card.index || 0
				childIndex = childIndex.toString().padStart(5, '0')
				familyLabels.push(childIndex)
				familyLabels.push(childLabel)
				return familyLabels.join(' / ')
			},

			babel_card_sort_epnum (babel_card) {
				let familyLabels = []
				let grandParentIndex = babel_card.grand_parent_index || 0
				grandParentIndex = grandParentIndex.toString().padStart(5, '0')
				familyLabels.push(grandParentIndex)
				let parentIndex = babel_card.parent_index || 0
				parentIndex = parentIndex.toString().padStart(5, '0')
				familyLabels.push(parentIndex)
				let childIndex = babel_card.index || 0
				childIndex = childIndex.toString().padStart(5, '0')
				familyLabels.push(childIndex)
				return familyLabels.join(' / ')
			},

			getStatusLabel (status) {
				if (status === window.vm.$getConst('CREATED')) return 'Crée'
				if (status === window.vm.$getConst('WAITING')) return 'En attente'
				if (status === window.vm.$getConst('PROCESSING')) return 'En traitement'
				if (status === window.vm.$getConst('DONE')) return 'Terminé'
				if (status === window.vm.$getConst('ERROR')) return 'En erreur'
				if (status === window.vm.$getConst('CANCELED')) return 'Annulé'
				if (status === window.vm.$getConst('VALIDATING')) return 'En validation'
				if (status === window.vm.$getConst('SKIPPED')) return 'Évité'
				if (status === window.vm.$getConst('RESETED')) return 'Réinitialisé'
				if (status === window.vm.$getConst('STOPPED')) return 'Stoppé'
				return 'inconnu'
			}

		}
	}
}

export default MAESTRO



// WEBPACK FOOTER //
// ./src/plugins/maestro.js